// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/dashboard_background_2.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;

    position: fixed;
    top: var(--header-height);
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px 40px;
}

.dashboard {
    background-color: white;
    padding: 25px 50px;
    border-radius: 10px;
    text-align: left;
    width: 300px;
    --webkit-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);
}

.dashboard > div {
    margin-bottom: 10px;
}
.dashboard > div:last-child {
    margin-bottom: 0;
}

.dashboard a {
    color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,yDAAsE;IACtE,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;;IAE5B,eAAe;IACf,yBAAyB;IACzB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,wDAAwD;IAExD,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".dashboard-container {\n    background-image: url(../../public/images/dashboard_background_2.webp);\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    position: fixed;\n    top: var(--header-height);\n    left: 0;\n    width: 100%;\n    height: 100%;\n    padding: 20px 40px;\n}\n\n.dashboard {\n    background-color: white;\n    padding: 25px 50px;\n    border-radius: 10px;\n    text-align: left;\n    width: 300px;\n    --webkit-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);\n    -moz-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);\n    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);\n}\n\n.dashboard > div {\n    margin-bottom: 10px;\n}\n.dashboard > div:last-child {\n    margin-bottom: 0;\n}\n\n.dashboard a {\n    color: var(--primary-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
